<template>
  <div class="progress-box" ref="controls" :class="playingStatus && 'p-pointer'" @mousedown="controlsMousedown">
    <div
      class="video-controls-progress"
    >
      <div
        :style="progress"
        ref="progressTime"
        class="video-controls-progress-time"
      >
        <i></i>
      </div>
      <div :style="buffered" class="video-controls-progress-buffered"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      startX: 0,
      progr: 0,
      moving: false,
    };
  },
  props: {
    playingStatus: {
      type: [Boolean, String],
    },
    progress: {
      type: [Object, String],
    },
    buffered: {
      type: [Object, String],
    },
  },
  mounted() {
    document.addEventListener("mouseup", () => {
      if (this.moving) {
        document.querySelector("video").play();
        this.moving = false;
      }
      document.removeEventListener("mousemove", this.controlsMousemove);
    });
  },
  methods: {
    // 控制点击
    controlsMousedown(e) {
      e.preventDefault();
      if (this.playingStatus) {
        // 操作限制
        this.startX = e.clientX;
        if (e.target.localName != "i") {
          this.progr = (e.offsetX / this.$refs.controls.offsetWidth) * 100;
          this.setControls(this.progr);
          document.querySelector("video").play();
        } else {
          // 点击圆点
          const progressTime = this.$refs.progressTime.offsetWidth;
          const controls = this.$refs.controls.offsetWidth;
          this.progr = (progressTime / controls) * 100;
        }
        document.addEventListener("mousemove", this.controlsMousemove, false);
      }
    },
    // 偏移
    controlsMousemove(e) {
      e.preventDefault();
      const movingX = e.clientX - this.startX;
      const moveProgress = (movingX / this.$refs.controls.offsetWidth) * 100;
      const progr = moveProgress + this.progr;
      const progrValue = progr >= 100 ? 100 : progr;
      this.moving = true;
      document.querySelector("video").pause();
      this.setControls(progrValue);
    },
    setControls(value) {
      const movingX = value;
      const duration = document.querySelector("video").duration;
      const currentTime = document.querySelector("video").currentTime;
      const current = (duration / 100) * movingX;
      this.$emit("setControlsProgress", movingX);
      if (movingX != 100) {
        // 结束
        this.$emit("currentTimeChang", current);
      }
    },
  },
  destoryed() {
    document.removeEventListener("mouseup");
  },
};
</script>

<style lang='less' scoped>
.progress-box{
  display: flex;
  align-items: center;
  width: 100%;
  height: 20px;
  margin: 0 16px 0 10px;
}
.video-controls-progress {
  width: 100%;
  
  background: #777777;
  position: relative;
  height: 2px;
  &-time {
    width: 0;
    background: rgba(77, 142, 246, 1);
    height: 2px;
    position: relative;
    margin-right: 10px;
    z-index: 1;
    i {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: -10px;
      top: -10px;
      width: 20px;
      height: 20px;
      background: rgba(77, 142, 246, 1);
      box-shadow: 0px 0px 8px rgba(25, 55, 255, 1);
      border-radius: 50%;
    }
  }
  &-buffered {
    background: #ffffff;
    height: 1px;
    position: absolute;
    top: 0;
    height: 2px;
  }
  &-top {
    position: absolute;
    text-align: center;
    width: 50px;
    height: 20px;
    top: -30px;
    margin-left: -26px;
  }
}
</style>